'use strict';
import angular from 'angular';
import FeedbackController from './feedback.controller';
export default angular.module('eeComUiApp.feedback', [])
    .component('feedback', {
    template: require('./feedback.html'),
    controller: FeedbackController
})
    .name;
//# sourceMappingURL=index.js.map